import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navigation } from "./components/landing/Navigation";
import { Hero } from "./components/landing/Hero";
import { About } from "./components/landing/About";
import { Services } from "./components/landing/Services";
import { Portfolio } from "./components/landing/Portfolio";
import { ValueProp } from "./components/landing/ValueProp";
import { Stats } from "./components/landing/Stats";
import { Testimonials } from "./components/landing/Testimonials";
import { Coverage } from "./components/landing/Coverage";
import { CTA } from "./components/landing/CTA";
import { Footer } from "./components/landing/Footer";
import { WhatsAppFloat } from "./components/landing/WhatsAppFloat";
import { Flyer } from "./components/Flyer";
import { BusinessCard } from "./components/BusinessCard";
import { BrandKit } from "./components/BrandKit";
import { Resources } from "./components/Resources";

const Home = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-brand-bg text-brand-text font-sans">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Services />
        <Portfolio />
        <ValueProp />
        <Stats />
        <Testimonials />
        <Coverage />
        <CTA />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/volantino" element={<Flyer />} />
          <Route path="/biglietto" element={<BusinessCard />} />
          <Route path="/brand-kit" element={<BrandKit />} />
          <Route path="/guide-risorse" element={<Resources />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
